export default "__VITE_ASSET__203ba90a__"